/**
 * Étagère de la cage : grille rangées × places. Chaque case = un emplacement
 * avec son code-barres ; on y voit le nombre de colis (et les premiers n°
 * en grand format). Les cases vides restent affichées.
 * emplacements : [{ id, ligne, colonne, code, colis?: [], nb? }]
 */
import { numeroLisible } from "@/lib/colisCode";

export function EtagereVisuel({ lettre, lignes, colonnes, emplacements = [], selection = null, actif = null, surligne = [],
  onSelect, compact = false, testId }) {
  const parCase = {};
  emplacements.forEach((e) => { parCase[`${e.ligne}-${e.colonne}`] = e; });
  const nb = (e) => (e?.nb ?? e?.colis?.length ?? 0);
  return (
    <div className="inline-block max-w-full" data-testid={testId}>
      <div className="flex items-center gap-2 mb-1.5">
        <span className={`inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground font-extrabold ${compact ? "w-6 h-6 text-xs" : "w-8 h-8 text-base"}`}>{lettre}</span>
        <span className={`font-semibold ${compact ? "text-xs" : "text-sm"}`}>Étagère {lettre}</span>
        <span className="text-xs text-muted-foreground">{emplacements.reduce((n, e) => n + nb(e), 0)} colis</span>
      </div>
      <div className="overflow-x-auto">
        <table className="border-collapse border-2 border-foreground/70 bg-card">
          <tbody>
            {Array.from({ length: lignes }, (_, l) => (
              <tr key={l}>
                {Array.from({ length: colonnes }, (_, c) => {
                  const e = parCase[`${l + 1}-${c + 1}`];
                  const n = nb(e);
                  const sel = e && selection === e.id;
                  const enCours = e && actif === e.id;
                  const hl = e && surligne.includes(e.id);
                  const fond = hl ? "bg-red-500/25" : enCours ? "bg-emerald-500/25" : sel ? "bg-primary/25" : n ? "bg-primary/10" : "";
                  const bord = hl ? "outline outline-[3px] -outline-offset-[3px] outline-red-500" : enCours ? "outline outline-[3px] -outline-offset-[3px] outline-emerald-500"
                    : sel ? "outline outline-[3px] -outline-offset-[3px] outline-primary" : "";
                  return (
                    <td key={c}
                      className={`border-2 border-foreground/70 align-top p-0 ${compact ? "w-14 h-11" : "w-28 h-20"} ${fond} ${bord} ${onSelect && e ? "cursor-pointer hover:bg-accent" : ""}`}
                      onClick={() => e && onSelect?.(e)} data-testid={e ? `case-${lettre}-${l + 1}-${c + 1}` : undefined} title={e ? `${e.nom || ""} — code ${e.code}` : ""}>
                      <div className={`h-full flex flex-col ${compact ? "p-0.5" : "p-1.5"}`}>
                        <span className={`font-mono text-muted-foreground truncate ${compact ? "text-[9px]" : "text-[10px]"}`}>{e ? e.code : "—"}</span>
                        <span className={`font-extrabold leading-none ${compact ? "text-base" : "text-2xl"} ${n ? "" : "text-muted-foreground/50"}`}>{n}</span>
                        {!compact && (e?.colis || []).slice(0, 2).map((x) => (
                          <span key={x.numero} className="font-mono text-[10px] truncate">{numeroLisible(x.numero)}</span>
                        ))}
                        {!compact && n > 2 && <span className="text-[10px] text-muted-foreground">+{n - 2}</span>}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
